import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionDetails } from '@material-ui/core';

import { SmallSectionHeader } from 'components/Typography';
import { OrangeButton } from 'components/Button';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
export const StyledDiv = styled.div`
  margin-top: 10px !important;
`;

export const StyledValidAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  border-left: 5px solid ${(props) => props.color};
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  margin-top: 20px !important;
  padding: 0 !important;
`;

export const StyledImg = styled(({ reverse, ...othersProps }) => (
  <img {...othersProps} alt="help-icon" />
))`
  margin: ${(props) => (!props.reverse ? '0 8px 0 0' : '0 0 0 8px')};
`;

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    font-size: 11px !important;
    font-weight: bold;
    padding: 8px 16px;
    text-align: start;
    justify-content: flex-start;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    padding: 8px 24px 16px;
    border-left: none;
  }
`;
